import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router";
import VueMeta from 'vue-meta';
import moment from "moment-jalaali";
import VuePageTransition from 'vue-page-transition'
import goTo from 'vuetify/lib/services/goto'
import './registerServiceWorker'
import "@/assets/styles/master.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/brands.css";
import "@/assets/styles/solid.min.css";
import "@/assets/styles/regular.min.css";
import "@/assets/styles/duotone.min.css";
import "@/assets/styles/vuetify.css";
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import * as  VueGoogleMaps from 'vue2-google-maps'
import VueGeolocation from 'vue-browser-geolocation'
import VuePreferences, {preference} from 'vue-preferences'
import VueHtmlToPaper from 'vue-html-to-paper';
import DatetimePicker from 'vuetify-datetime-picker'

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://cdn.rtlcss.com/bootstrap/v4.5.3/css/bootstrap.min.css'
    ],
    timeout: 1000, // default timeout before the print window appears
    autoClose: false, // if false, the window will not close after printing
    windowTitle: window.document.title, // override the window title

}

Vue.use(VueHtmlToPaper, options);
Vue.use(DatetimePicker)

Vue.prototype.$convertFarsiNumber = function () {
    let els = document.getElementsByTagName('input');
    for (let i = 0; i < els.length; i++) {
        els[i].addEventListener("keyup", (event) => {
            if (/([۰-۹])/g.test(event.target.value)) {
                event.target.value = event.target.value.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728))
            }
        });
    }
}


Vue.prototype.$baseUrl = "https://Pwa.asiagroup.click";
//Vue.prototype.$baseUrl = "https://localhost:44331";

Vue.prototype.$openLink = function (url) {
    /*var newWindow = window.open("about:blank", "_blank");
    newWindow.location = url;*/
    if (url !== null) {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.target = '_blank'
        // a.download = <your_fileName>;
        a.click();
        document.body.removeChild(a);
    }
}
Vue.prototype.$roles = [
    {
        id: 1,
        name: 'ادمین'
    }, {
        id: 2,
        name: 'سوپروایزر'
    }, {
        id: 3,
        name: 'پشتیبانی'
    }, {
        id: 4,
        name: 'مالی'
    }, {
        id: 5,
        name: 'مشتری'
    }, {
        id: 6,
        name: 'کارشناس ایزو'
    }, {
        id: 7,
        name: 'کارشناس املاک'
    }, {
        id: 8,
        name: 'کارشناس آموزش'
    }, {
        id: 9,
        name: 'کارشناس مدارک'
    },
]
Vue.prototype.$TypeTicketStatus = [
    {
        id: 1,
        name: 'جدید'
    },
    {
        id: 2,
        name: 'در حال بررسی'
    },
    {
        id: 3,
        name: 'پاسخ داده شده'
    },
    {
        id: 4,
        name: 'بستن توسط سیستم'
    },
    {
        id: 5,
        name: 'تایید مشتری'
    },
    {
        id: 6,
        name: 'پاسخ کاربر'
    },
    {
        id: 7,
        name: 'ارجاع داده شده'
    },
]
Vue.prototype.$TypeTaskStatus = [
    {
        id: 1,
        name: 'جدید'
    },
    {
        id: 2,
        name: 'انجام شده'
    },
    {
        id: 3,
        name: 'پاسخ داده شده'
    },
    {
        id: 4,
        name: 'در حال انجام'
    },
    {
        id: 5,
        name: 'لغو شده'
    },
]
Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null) {
        return httpUrl.replace('http://', 'https://');
    }
};
Vue.use(VuePreferences, {
    storage: window.localStorage,
    namespace: 'ticketing'
});
Vue.prototype.$typeTickets = []
Vue.use(VueAddtohomescreen);
Vue.use(VuePageTransition)

Vue.prototype.$setUserData = function (mobile, activeCode, token, role, username) {
    preference('userData', {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":"","username":""}'})
        .set(JSON.stringify({
            'mobile': mobile,
            'activeCode': activeCode,
            'token': token,
            'role': role,
            'username': username
        }));
};
Vue.prototype.$getUserData = function () {
    return JSON.parse(preference('userData',
        {defaultValue: '{"mobile":"", "activeCode":"","token":"","role":"","username":""}'}).get());
};
Vue.config.productionTip = false

Vue.prototype.$numberWithCommas = function (x) {
    if (x !== null && x !== undefined) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};
Vue.use(VueMeta);

/*Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBqLXDV8HIaaA2ATo8cFm99FMI75WYFNSg',
        libraries: '',
        language: 'fa'
    }
});*/
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBqLXDV8HIaaA2ATo8cFm99FMI75WYFNSg',
        libraries: "places",
        language: "fa"
    }
})
Vue.use(VueGeolocation)
Vue.prototype.$typePages = [
    {
        id: 1,
        name: 'درباره ما'
    },
    {
        id: 2,
        name: 'تماس با ما'
    },
    {
        id: 3,
        name: 'قوانین و مقررات'
    },
    {
        id: 4,
        name: 'سوالات متداول'
    }
]
Vue.prototype.$persianText = function (text) {
    var retText = "";

    switch (text) {
        case "Administrator" :
            retText = 'ادمین';
            break;
        case "SuperVisor" :
            retText = 'سوپروایزر';
            break;
        case "Support" :
            retText = 'پشتیبانی';
            break;
        case "Financial" :
            retText = 'مالی';
            break;
        case "Client" :
            retText = 'مشتری';
            break;
        case "IsoExpert" :
            retText = 'کارشناس ایزو';
            break;
        case "EstateExpert" :
            retText = 'کارشناس املاک';
            break;
        case "EducationExpert" :
            retText = 'کارشناس آموزش';
            break;
        case "CertExpert" :
            retText = 'کارشناس مدارک';
            break;


    }

    return retText;
}
Vue.prototype.$scrollTop = function (x) {
    return goTo(x);
}
Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jMM/jDD')
}

/*Vue.prototype.$setCssFiles = function () {
    if (window.location.href.toLowerCase().indexOf("automation") > -1) {

        import("@/assets/styles/masterAutomation.css");
    } else {
        import ("@/assets/styles/master.css");
    }

};*/
Vue.prototype.$printElement = async function (elementId, name) {
    const url = '';
    const win = this.openWindow(url, name);
    const element = document.getElementById(elementId);

    win.document.write(`
        <html>
          <head>
            <title>${name}</title>
            <link href="https://fonts.cdnfonts.com/css/iranian-sans" rel="stylesheet">
            <style>
                td{padding:15px;border-top: 1px solid #e1e1e1;}
                *, body {font-family: 'Iranian Sans', sans-serif;font-size:12px;}
            </style>
          </head>
          <body dir="rtl">
            ${element.innerHTML}
          </body>
        </html>
      `);

    setTimeout(() => {
        win.document.close();
        win.focus();
        win.print();
        setTimeout(function () {
            window.close();
        }, 1);
    }, 1000);
}
Vue.prototype.openWindow = function (url, name, props) {
    let windowRef = null;
    windowRef = window.open(url, name, props);
    if (!windowRef.opener) {
        windowRef.opener = self;
    }
    windowRef.focus();
    return windowRef;
};

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
